import Tutorial from './container';

export default Tutorial;
